var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.444336,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7137 10.9044H21.8747V10.8612H12.4997V15.0278H18.3867C17.5278 17.4534 15.22 19.1945 12.4997 19.1945C9.04811 19.1945 6.24967 16.3961 6.24967 12.9445C6.24967 9.49294 9.04811 6.6945 12.4997 6.6945C14.0929 6.6945 15.5424 7.29554 16.646 8.27731L19.5924 5.33096C17.732 3.5971 15.2434 2.52783 12.4997 2.52783C6.74707 2.52783 2.08301 7.1919 2.08301 12.9445C2.08301 18.6971 6.74707 23.3612 12.4997 23.3612C18.2523 23.3612 22.9163 18.6971 22.9163 12.9445C22.9163 12.2461 22.8445 11.5643 22.7137 10.9044Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28418 8.09606L6.70658 10.606C7.63262 8.31325 9.87533 6.6945 12.4998 6.6945C14.093 6.6945 15.5425 7.29554 16.6462 8.27731L19.5925 5.33096C17.7321 3.5971 15.2436 2.52783 12.4998 2.52783C8.49876 2.52783 5.02897 4.78669 3.28418 8.09606Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.3609C15.1906 23.3609 17.6354 22.3312 19.4839 20.6567L16.2599 17.9286C15.1789 18.7507 13.8581 19.1953 12.5 19.1942C9.79062 19.1942 7.4901 17.4666 6.62344 15.0557L3.22656 17.6729C4.95052 21.0463 8.45156 23.3609 12.5 23.3609Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7141 10.9041H21.875V10.8608H12.5V15.0275H18.387C17.9762 16.1819 17.2361 17.1906 16.2583 17.9291L16.2599 17.928L19.4839 20.6562C19.2557 20.8634 22.9167 18.1525 22.9167 12.9442C22.9167 12.2457 22.8448 11.564 22.7141 10.9041Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.44ded1984d2cee07e83a305a16c533f2.svg";
export { ForwardRef as ReactComponent };